import ApiFactory from './factory'
import declaration from './declarations'
import localSave from '@utils/local-save'

const token = (localSave.get('auth.currentUser') && localSave.get('auth.currentUser').token) || null

const Api = new ApiFactory(process.env.VUE_APP_API_BASE_URL + 'v3', declaration, token)

export default Api
